import type { JSX } from 'solid-js'
import { A } from '@solidjs/router'
import { Calendar, CalendarPlus, User, LogOut } from 'lucide-solid'
import { Show } from 'solid-js'

export const AppShellCustomer = (props: {
  tenantSlug: string
  tenantName: string
  logoUrl?: string | null
  heroUrl?: string | null
  /** booking_theme name; applies the salun-booking-theme-* palette globally */
  theme?: string | null
  customerName?: string
  title?: string
  children: JSX.Element
  onLogout?: () => void
}): JSX.Element => (
  <div
    class={
      'min-h-screen flex flex-col bg-bg pb-16 sm:pb-0 salun-booking-theme-' +
      (props.theme ?? 'default').replace(/[^a-z0-9-]/gi, '')
    }
  >
    <header class="h-14 bg-surface border-b border-border px-4 flex items-center gap-3">
      <Show
        when={props.logoUrl}
        fallback={<div class="w-8 h-8 bg-accent rounded-md" aria-hidden />}
      >
        <img
          src={props.logoUrl!}
          alt={props.tenantName}
          class="w-8 h-8 rounded-md object-cover"
        />
      </Show>
      <span class="font-display font-semibold text-fg flex-1 truncate">{props.tenantName}</span>
      <Show when={props.customerName}>
        <span class="text-sm text-muted hidden sm:inline">{props.customerName}</span>
      </Show>
      <Show when={props.onLogout}>
        <button
          onClick={props.onLogout}
          class="text-muted hover:text-fg"
          aria-label="Logout"
        >
          <LogOut size={18} />
        </button>
      </Show>
    </header>

    <Show when={props.heroUrl}>
      <div class="relative w-full max-w-screen-sm mx-auto">
        <img
          src={props.heroUrl!}
          alt=""
          class="w-full h-32 sm:h-40 object-cover"
          aria-hidden="true"
        />
      </div>
    </Show>

    <main class="flex-1 overflow-y-auto px-4 py-6 max-w-screen-sm mx-auto w-full">
      <Show when={props.title}>
        <h1 class="font-display text-2xl font-semibold mb-5">{props.title}</h1>
      </Show>
      {props.children}
      <p class="text-[11px] text-muted text-center mt-12 leading-relaxed">
        Vuoi gestire le prenotazioni del tuo salone come {props.tenantName}?
        <br />
        Scopri{' '}
        <a
          href="https://salun.it"
          target="_blank"
          rel="noopener noreferrer"
          class="text-accent font-semibold no-underline hover:underline"
        >
          salun.it
        </a>{' '}
        — agenda, OTP, statistiche e cassa fiscale.
      </p>
    </main>

    {/* Mobile bottom-nav — hidden on sm+ */}
    <nav class="fixed bottom-0 inset-x-0 sm:hidden bg-surface border-t border-border h-16 grid grid-cols-3">
      <A
        href={`/c/${props.tenantSlug}/bookings`}
        class="flex flex-col items-center justify-center gap-0.5 text-muted"
        activeClass="text-accent"
      >
        <Calendar size={20} />
        <span class="text-[10px]">Prenotazioni</span>
      </A>
      <A
        href={`/b/${props.tenantSlug}`}
        class="flex flex-col items-center justify-center gap-0.5 text-muted"
        activeClass="text-accent"
      >
        <CalendarPlus size={20} />
        <span class="text-[10px]">Prenota</span>
      </A>
      <A
        href={`/c/${props.tenantSlug}/profile`}
        class="flex flex-col items-center justify-center gap-0.5 text-muted"
        activeClass="text-accent"
      >
        <User size={20} />
        <span class="text-[10px]">Profilo</span>
      </A>
    </nav>
  </div>
)
